<script>
	// Stores 
	import { 
		mailProposta,
		propostaContatos
	} from '../store.js';    

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";
	import BarraAtendimento from '../components/BarraAtendimento.svelte';

	// Code
	let titlePage = 'Proposta de Administração de Condomínio';

	let fields = [
		{
			title:      'Seu nome *',
			name:       'nome',
			required:   'required'
		},
		{
			title:      'Telefone *',
			name:       'telefone',
			required:   'required',
			classe:     'mask-telefone'
		},
		{
			title:      'Email *',
			name:       'email',
			required:   'required',
			type:       'email'
		},
		{
			title:      'Você é síndico?',
			name:       'eh-sindico',
			type:       'select',
			selectValues: [
				{
					title: 'Selecione',
					value: ''
				},
				{
					title: 'Sim',
					value: 'Sim'
				},
				{
					title: 'Não',
					value: 'Não'
				}
			]
		},          
		{
			title:      'Nome do condomínio *',
			name:       'condominio-nome',
			required:   'required'
		},
		{
			title:      'Endereço *',
			name:       'condominio-endereco',
			required:   'required'
		},   
		{
			title:      'Número de unidades *',
			name:       'condominio-unidades',
			required:   'required'
		},   
		{
			title:      'Atual administradora *',
			name:       'condominio-adm',
			required:   'required'
		},		
		{
			title:      'Tipo de condomínio',
			name:       'tipo-condominio',
			type:       'select',
			selectValues: [
				{
					title: 'Residencial',
					value: 'Residencial'
				},
				{
					title: 'Comercial',
					value: 'Comercial'
				},
				{
					title: 'Misto',
					value: 'Misto'
				}
			]
		},    
		{
			title:      'Preferência de contato',
			name:       'preferencia-contato',
			type:       'select',
			selectValues: [
				{
					title: 'Por Whatsapp',
					value: 'Por Whatsapp'
				},
				{
					title: 'Por Email',
					value: 'Por Email'
				}
			]
		},    
		   
	];      
	
	const message = `
Seu nome: {nome}
Telefone: {telefone}
Email: {email}
Você é síndico?: {eh-sindico}
Nome do condomínio: {condominio-nome}
Atual administradora: {condominio-adm}
Endereço: {condominio-endereco}
Número de unidade: {condominio-unidades}
Tipo de condomínio: {tipo-condominio}
Preferência de contato: {preferencia-contato}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}
</script>

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p>Estamos prontos para lhe assessorar e indicar as melhores escolhas para o seu condomínio. Venha nos conhecer ou solicite uma proposta utilizando o formulário.</p>
		</div>
	</div>
</PageHeader>

<div class="container">
	<div class="grid grid-size--2 grid-size-sm--1">
		<BarraAtendimento contatos={$propostaContatos} />
		<section class="atendimento">
			<div class="text-center">
				<h3><i class="far fa-envelope color-secondary"></i> Solicite uma proposta</h3>
			</div>	
			<div class="flex flex-center mt-20 mb-20">
				<div class="flex-1 background-gray round-all pa-30">
					<Forms fields={fields} destiny={$mailProposta} subjectTitle="{titlePage}" {message} htmlbody={false} />
				</div>
			</div>
		</section>
	</div>
</div>